<script setup lang="ts">
    import { computed } from 'vue';

    type Props = {
        tags: string[];
    };

    const props = defineProps<Props>();

    const showTags = computed(() => props.tags.length > 0);
</script>

<template>
    <div
        v-if="showTags"
        class="box">
        <p class="title is-5">
            Library groups
        </p>
        <div class="tags are-medium">
            <span
                v-for="(tag, idx) in props.tags"
                :key="idx"
                class="tag is-info">{{ tag }}</span>
        </div>
    </div>
</template>
